//import React, { useState } from "react"
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer"
import RptInvoice from "./RptInvoice"
import RptDbcrNote from "./RptDbcrNote"
import RptVoucher from "./RptVoucher"
import { useSelector } from "react-redux"
import { enum_Report_Type } from "./ReportUtility"
import RptChallan from "./RptChallan"
import RptChallanWithoutTaka from "./RptChallanWithoutTaka"
import RptSaleOrderForm from "./RptSaleOrderForm"


const ReportViewer = ({ props_ReportType }) => {

  const { detail } = useSelector((state) => state.invoice)
  const { recVouDetail } = useSelector((state) => state.receiveEntry)
  const { payVouDetail } = useSelector((state) => state.paymentEntry)
  const { rptChallanData } = useSelector((state) => state.saleEntry)
  const { orderData } = useSelector((state) => state.saleOrderEntry)
  const randomPdfName = Math.random().toString(36).substring(2, 7)
console.log(orderData,"ord") 
  return (
    <div>

      {(detail && detail?.length > 0) || (payVouDetail && payVouDetail?.length > 0) || (recVouDetail && recVouDetail?.length > 0)
        || (rptChallanData && Object.keys(rptChallanData).length > 0)||(orderData && orderData?.length > 0)
        ? (
          <div style={{ width: "100%", height: "300px", margin: 10 }}>
            {/* <PDFViewer width="100%" height="650">
              <RptSaleOrderForm data={orderData} />
            </PDFViewer> */}
            <PDFDownloadLink
              document={props_ReportType === enum_Report_Type.SALESINVOICE ? <RptInvoice detail={detail} /> :
                props_ReportType === enum_Report_Type.DBCRNote ? <RptDbcrNote detail={detail} /> :
                  props_ReportType === enum_Report_Type.RecVoucher ? <RptVoucher data={recVouDetail} /> :
                    props_ReportType === enum_Report_Type.PayVoucher ? <RptVoucher data={payVouDetail} /> :
                      props_ReportType === enum_Report_Type.GrayChallan ? <RptChallan chaldata={rptChallanData} /> :
                      props_ReportType === enum_Report_Type.GrayChallanWithoutTaka ? <RptChallanWithoutTaka chaldata={rptChallanData} /> :
                      props_ReportType === enum_Report_Type.SaleOrderForm ? <RptSaleOrderForm data={orderData} /> :
                        ""}
              fileName={randomPdfName + ".pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? (
                  "Loading document..."
                ) :
                  ((props_ReportType == enum_Report_Type.SALESINVOICE || props_ReportType == enum_Report_Type.DBCRNote) && detail?.length > 0)
                    || (props_ReportType == enum_Report_Type.RecVoucher && recVouDetail && recVouDetail?.length > 0)
                    || (props_ReportType == enum_Report_Type.PayVoucher && payVouDetail && payVouDetail?.length > 0)
                    || (props_ReportType == enum_Report_Type.GrayChallan && rptChallanData && Object.keys(rptChallanData).length > 0)
                    || (props_ReportType == enum_Report_Type.GrayChallanWithoutTaka && rptChallanData && Object.keys(rptChallanData).length > 0)
                     || (props_ReportType == enum_Report_Type.SaleOrderForm && orderData && orderData?.length > 0)
                    ? (
                      <div
                        style={{
                          background: "rgb(0, 72, 154)",
                          textAlign: "center",
                          color: "white",
                          padding: "10px",
                        }}
                      >
                        Download
                      </div>
                    ) : "Loading document..."
              }
            </PDFDownloadLink>
          </div>
        ) : (
          <div
            style={{
              background: "rgb(0, 72, 154)",
              textAlign: "center",
              color: "white",
              padding: "10px",
              marginBottom: "10px"
            }}
          >
            Data not found

          </div>
        )}
    </div>
  )
}
export default ReportViewer
